module.exports = __webpack_public_path__ + "static/media/zapai.8a2d15f4.png";